import API from '../utils/request'
import { getToken } from '../utils/auth'

export function getUserInfo () {
  console.log('getToken', getToken())
  return API.get('/management/login/getUserInfo', { token: getToken() })
}
